import { useMemo } from 'react';

import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { fieldConfigsSelector, selectedLicenseTypeSelector } from '../../License/store/selectors';
import { type Flow } from '../../License/types/enums';

import useLicenseAbbreviation from '../../../hooks/useLicenseAbbreviation';
import { LicenseTypeNature } from '../../../types';

import getConsignmentTabFields from '../helpers/getConsignmentTabFields';
import getHeaderTabFields from '../helpers/getHeaderTabFields';

function useTabFields() {
  const {
    t,
    i18n: { language },
  } = useTranslation();

  const licenseTypeData = useSelector(selectedLicenseTypeSelector).data?.licenseTypeResponse;
  const fieldConfigs = useSelector(fieldConfigsSelector);
  const { licenseTypeNature, flow } = licenseTypeData ?? {};
  const licenseAbbreviation = useLicenseAbbreviation();

  const headerTabFields = useMemo(
    () =>
      licenseTypeData
        ? getHeaderTabFields({
            licenseType: licenseTypeData,
            fieldConfigs,
            t,
            licenseAbbreviation,
            locale: language as string,
          })
        : [],
    [language, licenseAbbreviation, licenseTypeData, t]
  );

  const consignmentTabFields = useMemo(
    () => (licenseTypeNature === LicenseTypeNature.EPHYTO ? getConsignmentTabFields(flow as Flow) : []),
    [flow, licenseTypeNature]
  );

  return {
    headerTabFields,
    consignmentTabFields,
  };
}

export default useTabFields;
